import { ContextType, useContext } from "react";

import { GeoContext } from "../../contexts/geo";

export default function useGeo(): ContextType<typeof GeoContext> {
  return useContext(GeoContext);
}
